/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Point} from "../../../models/point";
import {ObjectInstance} from "../../../models/object-instance";

// Breadcrumb class stores old positions of icon
// Point and Date are available to allow UI to show the number of breadcrumbs based on distance or time
export class Breadcrumb {
  icon: createjs.Bitmap;
  point: Point;
  date: Date;
}

export class PersonUI {
  mPerson: ObjectInstance;
  breadcrumbs: Breadcrumb[] = [];
  mIcon: createjs.Bitmap;
  mLastPosition: Point;
}
